const map: Record<PubSubEvent, Set<Listener>> = {} as Record<
  PubSubEvent,
  Set<Listener>
>;

export type Listener = (detail: Record<string, unknown>) => void;

export type PubSubEvent =
  | "addToBag"
  | "addToWishlist"
  | "membershipCancelled"
  | "membershipExtended"
  | "membershipUpgraded"
  | "page element clicked"
  | "page element viewed"
  | "productClicked"
  | "productListViewed"
  | "removeFromBag"
  | "removeFromWishlist"
  | "swiper.onslidechange"
  | "video.onended"
  | "video.onpause"
  | "video.onplay"
  | "carousel viewed";

export function dispatch(
  type: PubSubEvent,
  detail: Record<string, unknown>
): void {
  const listeners = map[type];
  if (!listeners) return;
  listeners.forEach((fn) => {
    try {
      fn(detail);
    } catch (e) {
      console.error(e);
    }
  });
}

export function subscribe(type: PubSubEvent, listener: Listener): void {
  map[type] = map[type] || new Set<Listener>();
  if (map[type].has(listener)) {
    return;
  }
  map[type].add(listener);
}
